import { PortalDsBadge } from 'src/components/portal-design-system';
import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import { getUserInitials, normaliseFlags } from '../utils/user-journey.utils';
import type { UserJourney } from '../types/user-journey.types';

interface UserJourneyHeaderProps {
  journey: UserJourney;
}

function formatJoinDate(joinedAt: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(joinedAt));
}

function formatTierLabel(tier: string): string {
  return tier
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function UserJourneyHeader({ journey }: UserJourneyHeaderProps) {
  const flags = normaliseFlags(journey.flags);

  return (
    <div className="flex flex-wrap items-start gap-4">
      <div
        aria-hidden
        className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#EDEEF2] text-base font-bold text-[#3D4155]"
      >
        {getUserInitials(journey.name)}
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className={cn(portalDs.sectionTitle, 'text-2xl')}>{journey.name}</h1>
          {flags.map((flag) => (
            <PortalDsBadge key={flag.code} pill variant="amber">
              {flag.label}
            </PortalDsBadge>
          ))}
        </div>

        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[13px] text-[#5E6278]">
          <span>{journey.workspace_name ?? 'No workspace'}</span>
          <span>{formatTierLabel(journey.tier)}</span>
          <span>Joined {formatJoinDate(journey.joined_at)}</span>
        </div>
      </div>
    </div>
  );
}
